import { IS_STAGING } from '@/config';

export default function checkStaging({ meta: { staging } = {} }, from, next) {
  if (!staging || (staging && IS_STAGING)) next();
}
